(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // any open search dropdown (modal or the header bar) keeps the header in place
      if ([...this.querySelectorAll('predictive-search')].some((p) => p.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      // desktop: the compact header (logo + search + icons) stays on screen; phones keep hide-on-scroll
      if (window.matchMedia('(min-width: 990px)').matches) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
        const movedDown = this.smMovedEnough('down'); // always track direction, even when already folded
        if (!this.header.classList.contains('sm-nav-folded') && movedDown) {
          // Folding the menu row must not change the page height, or the browser moves the scroll
          // position, which reads as "scrolling up" and unfolds it again (freeze/flicker loop).
          const before = this.header.offsetHeight;
          this.header.classList.add('sm-nav-folded');
          this.header.style.marginBottom = before - this.header.offsetHeight + 'px';
        }
        this.closeMenuDisclosure();
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      // desktop: only unfold after a real scroll up, not a trackpad wobble of a few pixels.
      // Product pages (Noon style): the menu row stays folded until you're back at the top, so the
      // header keeps one height and the pinned photo column doesn't jump (reset() unfolds it there).
      const smDesk = window.matchMedia('(min-width: 990px)').matches;
      const smKeepFolded = smDesk && /\/products\//.test(location.pathname);
      if (!smDesk || (!smKeepFolded && this.smMovedEnough('up'))) this.unfoldNav();
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.unfoldNav();
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Has the shopper scrolled at least 40px in this direction since it last changed?
    smMovedEnough(dir) {
      const y = window.pageYOffset || document.documentElement.scrollTop;
      if (this.smDir !== dir) {
        this.smDir = dir;
        this.smTurnY = y;
      }
      return Math.abs(y - this.smTurnY) >= 40;
    }

    unfoldNav() {
      if (!this.header.classList.contains('sm-nav-folded')) return;
      this.header.classList.remove('sm-nav-folded');
      this.header.style.marginBottom = '';
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
